var consumer = {
  "units": {
    "Wh": {
      "single": "Wattstunde",
      "plural": "Wattstunden",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "Die Energieproduktion und der -verbrauch werden in Wattstunden (Wh) gemessen. Eine Kilowattstunde (kWh) entspricht 1.000 Wattstunden, und diese Einheit wird üblicherweise von Stromanbietern in den Monatsabrechnungen verwendet."
    },
    "kWh": {
      "single": "Kilowattstunde",
      "plural": "Kilowattstunden",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "Megawattstunde",
      "plural": "Megawattstunden",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "Gigawattstunde",
      "plural": "Gigawattstunden",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "Terawattstunde",
      "plural": "Terawattstunden",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "Petawattstunde",
      "plural": "Petawattstunden",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "Exawattstunde",
      "plural": "Exawattstunden",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "Zettawattstunde",
      "plural": "Zettawattstunden",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "Yottawattstunde",
      "plural": "Yottawattstunden",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "Watt",
      "plural": "Watt",
      "annotated_abv": "(W)",
      "abv": "W"
    },
    "kW": {
      "single": "Kilowatt",
      "plural": "Kilowatt",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "Megawatt",
      "plural": "Megawatt",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "Gigawatt",
      "plural": "Gigawatt",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "Terawatt",
      "plural": "Terawatt",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "Petawatt",
      "plural": "Petawatt",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "Exawatt",
      "plural": "Exawatt",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "Zettawatt",
      "plural": "Zettawatt",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "Yottawatt",
      "plural": "Yottawatt",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "Prozent",
      "plural": "Prozent",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "Minuten",
      "ltone": "Minute",
      "single": "Minute",
      "plural": "Minuten"
    },
    "hours": {
      "zero": "Stunden",
      "ltone": "Stunde",
      "single": "Stunde",
      "plural": "Stunden"
    },
    "months": {
      "zero": "Monate",
      "ltone": "Monat",
      "single": "Monat",
      "plural": "Monate"
    },
    "years": {
      "zero": "Jahre",
      "ltone": " Jahr",
      "single": " Jahr",
      "plural": "Jahre"
    },
    "days": {
      "zero": "Tage",
      "ltone": "Tag",
      "single": "Tag",
      "plural": "Tage"
    },
    "nights": {
      "zero": "Nächte",
      "ltone": "Nacht",
      "single": "Nacht",
      "plural": "Nächte"
    },
    "batteries": {
      "zero": "Batterien",
      "ltone": "Batterie",
      "single": "Batterie",
      "plural": "Batterien"
    },
    "trees": {
      "zero": "Bäume",
      "ltone": "Baum",
      "single": "Baum",
      "plural": "Bäume"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kgs"
    },
    "laps": {
      "zero": "Runden",
      "ltone": "Runde",
      "single": "Runde",
      "plural": "Runden"
    },
    "barrels": {
      "zero": "Barrel",
      "ltone": "Barrel",
      "single": "Barrel",
      "plural": "Barrel"
    },
    "flights": {
      "zero": "Flüge",
      "ltone": "Flug",
      "single": "Flug",
      "plural": "Flüge"
    },
    "launches": {
      "zero": "Starts",
      "ltone": "Start",
      "single": "Start",
      "plural": "Starts"
    }
  },
  "timeAgo": {
    "now": "Jetzt",
    "second": {
      "single": "vor 1 Sekunde",
      "plural": "vor %{number} Sekunden"
    },
    "minute": {
      "single": "vor 1 Minute",
      "plural": "vor %{number} Minuten"
    },
    "hour": {
      "single": "vor 1 Stunde",
      "plural": "vor %{number} Stunden"
    },
    "day": {
      "single": "vor 1 Tag",
      "plural": "vor %{number} Tagen"
    },
    "week": {
      "single": "vor 1 Woche",
      "plural": "vor %{number} Wochen"
    },
    "month": {
      "single": "vor 1 Monat",
      "plural": "vor %{number} Monaten"
    },
    "year": {
      "single": "vor 1 Jahr",
      "plural": "vor %{number} Jahren"
    }
  },
  "weather": {
    "unknown": "Unbekannte Wetterlage",
    "footer": "Die Wetterdaten wurden von The Weather Company bereitgestellt.",
    "credit": "Bereitgestellt von The Weather Company"
  },
  "reports": {
    "title": "Berichte",
    "submit": "Bericht ausführen",
    "to": "zu",
    "selectDate": "Select the date",
    "insufficientData": "Bitte schauen Sie morgen wieder vorbei. Die Enphase Cloud hat die erforderlichen Daten zum Erstellen von Berichten nicht erfasst.",
    "1": {
      "name": "Tägliche Energieerzeugung",
      "title": "Energieerzeugung der Anlage",
      "description": "Zusammenfassung der täglichen Energieproduktion an diesem Standort. Da in diesem Bericht die Energie pro Tag angegeben ist, können Sie das Datum bis gestern anfordern."
    },
    "2": {
      "name": "Energieerzeugung in letzter Zeit",
      "title": "Stromerzeugung der Anlage in letzter Zeit",
      "description": "Zusammenfassung der Energieproduktion der letzten Woche an diesem Standort im 5-Minutentakt."
    },
    "6": {
      "name": "Monatliche Energieerzeugung",
      "title": "Monatliche Energieerzeugung",
      "description": "Zusammenfassung der Energieerzeugung eines Monats und maximale Leistung dieses Standorts."
    },
    "15": {
      "name": "Täglicher Verbrauch",
      "title": "Energieverbrauch der Anlage",
      "description": "Zusammenfassung des täglichen Energieverbrauchs an diesem Standort. Da in diesem Bericht die Energie pro Tag angegeben ist, können Sie das Datum bis gestern anfordern."
    },
    "16": {
      "name": "Verbrauch in letzter Zeit",
      "title": "Stromverbrauch der Anlage in letzter Zeit",
      "description": "Zusammenfassung des Energieverbrauchs der letzten Woche an diesem Standort im 15-Minutentakt."
    },
    "17": {
      "name": "Monatliche Nettoenergie",
      "title": "Monatliche Nettoenergie",
      "description": "In diesem Bericht wird die erzeugte, verbrauchte, importierte und exportierte Energie der Anlage für alle 15 Minuten im ausgewählten Monat zusammengefasst. Wenn im System auch AC-Batterien enthalten sind, wird im Bericht auch angegeben, welche Energie gespeichert und entladen wurde."
    },
    "19": {
      "name": "Batteriebericht",
      "title": "Batteriebericht",
      "description": "Dieser Bericht enthält die Batteriedaten der letzten 7 Tage"
    },
    "3": {
      "name": "Energieerzeugung pro Modul an einem Tag",
      "title": "Energieerzeugung pro Modul an einem Tag",
      "description": "In diesem Bericht ist die Energieerzeugung aller Mikro-Wechselrichter für das angegebene Datum angegeben."
    },
    "5": {
      "name": "Energieerzeugung pro Modul in einem Monat",
      "title": "Energieerzeugung pro Modul in einem Monat",
      "description": "In diesem Bericht ist die Energieerzeugung aller Mikro-Wechselrichter für den angegebenen Monat angegeben."
    },
    "20": {
      "name": "IQ Relay-Selbsttestbericht",
      "title": "Bericht zu den Ergebnissen des IQ-Relay Selbsttests",
      "description": "Dieser Bericht enthält die neuesten Ergebnisse des IQ Relay-Selbsttests"
    },
    "25": {
      "name": "Benutzerdefinierter Bericht (in Wh)",
      "title": "Benutzerdefinierter Bericht",
      "description": ""
    }
  },
  "stats": {
    "total": "Energie gesamt",
    "peak_production": "Spitzenleistung",
    "latest_production": "Neueste Leistung",
    "peak_consumption": "Spitzenverbrauch",
    "latest_consumption": "Letzter Verbrauch",
    "recent_power": "Letzte Energie",
    "maintainer": "Wenden Sie sich an den Kundenservice",
    "enphase": "Enphase-Support kontaktieren",
    "orenphase": "Oder kontaktieren Sie den Enphase Support",
    "learn_more": "Weitere Informationen.",
    "where": "Was verursacht das Problem?",
    "toGrid": "Ca. %{value} ins Netz exportiert",
    "fromGrid": "Ca. %{value} vom Netz importiert",
    "normal": {
      "title": "Normal",
      "modal": "Ihr System funktioniert ordnungsgemäß."
    },
    "shortcomm": {
      "title": "Keine Daten vom Gateway",
      "hours": "Ihr System hat in den letzten %{hours} Stunden keine Daten an die Enphase cloud gemeldet.",
      "date": "Ihr System hat seit dem %{date} keine Daten an die Enphase cloud gemeldet.",
      "unknown": "Dieses System meldet sich nicht bei der Enphase cloud.",
      "question": "Ist Ihre Internetverbindung unterbrochen?",
      "help_topic_link": "Stellen Sie wieder eine Verbindung her, um die Leistung Ihres Systems zu ermitteln",
      "link": "Klicken Sie hier, um Hilfe zu erhalten."
    },
    "meter": {
      "title": "Keine Berichte vom Messgerät",
      "hours": "Das Messgerät Ihres Systems hat während der letzten %{hours} Stunden keine Daten an das Gateway übertragen.",
      "date": "Das Messgerät Ihres Systems hat seit dem %{date} keine Daten an das Gateway übertragen.",
      "ct_wiring": "Es gibt ein Problem mit den Messgerätdaten Ihres Gateways. Wenden Sie sich an Ihren Instandhalter, um Hilfe zu erhalten.",
      "unknown": "Das Messgerät Ihres Systems sendet keine Daten an das Gateway.",
      "link": "Klicken Sie hier, um Hilfe zu erhalten.",
      "modal": "Keine Datenübertragung vom Messgerät an das Gateway seit"
    },
    "meter_issue": {
      "title": "Messgerätproblem",
      "ct_wiring": "Bei den Messungen Ihres Envoy-Messgeräts ist ein Problem aufgetreten.",
      "link": "Klicken Sie hier, um Hilfe zu erhalten."
    },
    "battery": {
      "title": "Kein Bericht von AC-Batterien",
      "modal": "Diese Batterie sendet keine Berichtsdaten.",
      "message": "Einige AC-Batterien senden keine Berichtsdaten.",
      "messageSome": "Einige AC-Batterien (%{count}) senden keine Berichtsdaten.",
      "link": "Klicken Sie hier, um Hilfe zu erhalten."
    },
    "storage_idle": {
      "title": "Speicherplatz inaktiv",
      "modal": "Diese AC-Batterie wird nicht ge- oder entladen.",
      "date": "Mindestens eine AC-Batterie wurde seit %{date} nicht mehr ge- oder entladen.",
      "unknown": "Mindestens eine AC-Batterie wird nicht ge- oder entladen.",
      "link": "Klicken Sie hier, um Hilfe zu erhalten."
    },
    "encharge": {
      "title": "Keine Daten von der Batterie",
      "modal": "Diese Batterie sendet keine Daten.",
      "message": "Batterie sendet keine Daten.Dies kann geschehen, wenn die kabellose Kommunikation zwischen Ihrem Gateway und der Batterie schwach ist.Dabei kann es sich um eine vorübergehende Störung handeln, die schnell vorübergeht.",
      "requestMaintainer": "Wenn das Problem bestehen bleibt, sollten Sie Ihren Instandhalter hinzuziehen.",
      "messageSome": "Einige Batterien (%{count}) senden keine Daten.",
      "link": "Klicken Sie hier für Hilfe."
    },
    "enpower": {
      "title": "Keine Daten vom Systemcontroller",
      "modal": "Dieser Systemcontroller sendet keine Daten.",
      "message": "Systemcontroller sendet keine Daten.Dies kann geschehen, wenn die kabellose Kommunikation zwischen Ihrem Gateway und dem Systemcontroller störungsanfällig ist.Dabei kann es sich um eine vorübergehende Störung handeln, die schnell vorübergeht.",
      "requestMaintainer": "Wenn das Problem bestehen bleibt, sollten Sie Ihren Instandhalter hinzuziehen.",
      "messageSome": "Einige Systemcontroller (%{count}) senden keine Daten.",
      "link": "Klicken Sie hier für Hilfe."
    },
    "encharge_issue": {
      "title": "Batteriefehler",
      "modal": "Bei dieser Batterie ist ein Fehler aufgetreten.",
      "message": "Fehler bei Batterie."
    },
    "enpower_issue": {
      "title": "Systemcontroller-Fehler",
      "modal": "Bei diesem Systemcontroller ist ein Fehler aufgetreten.",
      "message": "Fehler bei Systemcontroller."
    },
    "micro": {
      "title": "Keine Berichte von den Mikro-Wechselrichtern",
      "modal": "Dieser Mikro-Wechselrichter sendet keine Daten an das Gateway.",
      "message": "Einige Mikro-Wechselrichter senden keine Daten an das Gateway.",
      "messageSome": "Einige Mikro-Wechselrichter (%{count}) senden keine Daten an das Gateway.",
      "messageAll": "Keine der Mikro-Wechselrichter senden Daten an das Gateway.",
      "link": "Klicken Sie hier, um Hilfe zu erhalten."
    },
    "power": {
      "title": "System – Produktionsproblem",
      "message": "Es gibt einen Produktionsfehler bei Ihrem System.",
      "messageSome": "Dieser Mikrowechselrichter meldet einen Produktionsfehler.",
      "messageThreshold": "Ihr System produziert weniger Energie als erwartet.",
      "link": "Wenden Sie sich an den Enphase-Support.",
      "maintainerlink": "Wenden Sie sich an den Kundenservice, um Hilfe zu erhalten."
    }
  }
};
module.exports = consumer;